import { supplierCategorySchema } from '@amore/shared'
import { createFileRoute, Outlet } from '@tanstack/react-router'
import { z } from 'zod'
import { weddingSuppliersQueryOptions } from '@/features/suppliers/api'

const searchSchema = z.object({
  tab: z.enum(['mine', 'catalog']).optional().catch(undefined),
  search: z.string().optional().catch(undefined),
  category: supplierCategorySchema.optional().catch(undefined),
  view: z.enum(['tiles', 'list']).optional().catch(undefined),
})

export const Route = createFileRoute('/_auth/w/$workspaceSlug/suppliers')({
  validateSearch: (search) => searchSchema.parse(search),
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(weddingSuppliersQueryOptions(params.workspaceSlug)),
  component: Outlet,
})
